const fireplace = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="18" height="3" fill="black" />
    <rect x="5" y="7" width="3.5" height="2" fill="black" />
    <rect x="9.5" y="7" width="5" height="2" fill="black" />
    <rect x="15.5" y="7" width="3.5" height="2" fill="black" />
    <rect x="5" y="10" width="6.5" height="2" fill="black" />
    <rect x="12.5" y="10" width="6.5" height="2" fill="black" />
    <rect x="5" y="13" width="3.5" height="2" fill="black" />
    <rect x="9.5" y="13" width="5" height="2" fill="black" />
    <rect x="15.5" y="13" width="3.5" height="2" fill="black" />
    <rect x="5" y="16" width="6.5" height="2" fill="black" />
    <rect x="12.5" y="16" width="6.5" height="2" fill="black" />
    <rect x="5" y="19" width="3.5" height="2" fill="black" />
    <rect x="9.5" y="19" width="5" height="2" fill="black" />
    <rect x="15.5" y="19" width="3.5" height="2" fill="black" />
  </svg>
);
export default fireplace;
